export default __webpack_public_path__ + "static/media/welcome-bg5.627a902a.png";